import React, { useState, useEffect } from 'react';
import { getPagesContent, updatePageContent } from '../firebase/services';

const PAGES = [
  { id: 'about', title: 'About Us' },
  { id: 'privacy', title: 'Privacy Policy' },
  { id: 'refund', title: 'Refund Policy' },
  { id: 'shipping', title: 'Shipping Policy' },
  { id: 'terms', title: 'Terms of Service' },
  { id: 'contact', title: 'Contact Us' },
  { id: 'faq', title: 'FAQ' }
];

const ManagePages = () => {
  const [selectedPage, setSelectedPage] = useState(PAGES[0].id);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [allPagesData, setAllPagesData] = useState({});

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (allPagesData[selectedPage]) {
      setContent(allPagesData[selectedPage]);
    } else {
      setContent('');
    }
  }, [selectedPage, allPagesData]);

  const fetchData = async () => {
    setLoading(true);
    const data = await getPagesContent();
    setAllPagesData(data || {});
    setLoading(false);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await updatePageContent(selectedPage, content);
      setAllPagesData(prev => ({ ...prev, [selectedPage]: content }));
      alert('Page content updated successfully!');
    } catch (error) {
      console.error(error);
      alert('Failed to update page content.');
    }
    setSaving(false);
  };

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h2>Manage Pages</h2>
        <p>Edit the content of your information pages</p>
      </div>

      <div className="admin-card">
        <div className="card-header">
          <h3><ion-icon name="document-text-outline"></ion-icon> Edit Page Content</h3>
        </div>
        
        <div className="input-group">
          <label>Select Page</label>
          <select 
            value={selectedPage} 
            onChange={(e) => setSelectedPage(e.target.value)}
            className="custom-select"
          >
            {PAGES.map(page => (
              <option key={page.id} value={page.id}>{page.title}</option>
            ))}
          </select>
        </div>

        {loading ? (
          <div style={{textAlign: 'center', padding: '40px', color: '#6b7280'}}>
              <p>Loading content...</p>
          </div>
        ) : (
          <div className="input-group">
            <label>Page Content (Text)</label>
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              className="custom-textarea"
              rows="15"
              placeholder="Enter page content here..."
            />
            <small className="helper-text">
              You can use simple text. HTML is not fully supported yet but text will be preserved.
            </small>
          </div>
        )}

        <button 
          className="btn-primary" 
          onClick={handleSave} 
          disabled={saving || loading}
        >
          {saving ? 'Saving...' : (
              <>
                  <ion-icon name="save-outline"></ion-icon> Save Content
              </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ManagePages;
